
import { computed, defineComponent, PropType } from 'vue';
import ExpandHeightToggle from '@/shared/ExpandHeightToggle.vue';
import { TextTileModel } from '@/types/B2BcontentServerContract';
import CMSLinkHandler from '@/shared/content/blocks/helpers/CMSLinkHandler.vue';
import breakpointsState from '@/core/responsive/breakpoints/breakpoints-state.observable';

export default defineComponent({
    name: 'TextTile',
    components: {
        CMSLinkHandler,
        ExpandHeightToggle,
    },
    props: {
        content: {
            type: Object as PropType<TextTileModel>,
            required: true,
        },
    },
    setup(props) {
        const showReadMoreToggle = computed(() => {
            const isMobileOrTablet = breakpointsState.activeBreakpoint === 'xs' || breakpointsState.activeBreakpoint === 'sm' || breakpointsState.activeBreakpoint === 'md';
            return props.content.readMoreText || (isMobileOrTablet && props.content.seoText);
        });

        return {
            showReadMoreToggle,
        };
    },
});
